import { EXPLORE_DIFFERENT_VOCAB_MODAL_DISMISSED_UNTIL_STORAGE_KEY } from 'src/constants/storageKeys.const';
import { ONE_DAY_IN_MILLISECONDS } from 'src/constants/times.const';
import { getLocalStorageEntry, setLocalStorageEntry } from 'src/utils/webStorageUtils';

export const EXPLORE_DIFFERENT_VOCAB_MODAL_SUPPRESSION_MS = 14 * ONE_DAY_IN_MILLISECONDS;

export const isExploreDifferentVocabModalSuppressed = (now = Date.now()): boolean => {
  const dismissedUntil = getLocalStorageEntry(
    EXPLORE_DIFFERENT_VOCAB_MODAL_DISMISSED_UNTIL_STORAGE_KEY,
  );
  if (!dismissedUntil) return false;

  const expiresAt = Date.parse(dismissedUntil);
  if (Number.isNaN(expiresAt)) return false;

  return now < expiresAt;
};

export const suppressExploreDifferentVocabModal = (now = Date.now()) => {
  setLocalStorageEntry(
    EXPLORE_DIFFERENT_VOCAB_MODAL_DISMISSED_UNTIL_STORAGE_KEY,
    new Date(now + EXPLORE_DIFFERENT_VOCAB_MODAL_SUPPRESSION_MS).toISOString(),
  );
};
